import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHelmet = ({
  title = 'ADT Express - Envoi Colis Côte d\'Ivoire | Fret Maritime Paris Abidjan',
  description = 'Envoi colis Côte d\'Ivoire, barrique Abidjan, fret maritime Paris Abidjan. Transport conteneur France Côte d\'Ivoire avec suivi en temps réel. Devis gratuit.',
  keywords = 'envoi colis Côte d\'Ivoire, barrique Abidjan, fret maritime Paris Abidjan, transport conteneur France Côte d\'Ivoire, envoyer barrique Côte d\'Ivoire, groupage maritime, tarif envoi Abidjan',
  canonicalUrl,
  ogImage = 'https://adttracki9517back.builtwithrocket.new/assets/images/banniere_adt-1763665656406.png',
  ogType = 'website',
  structuredData,
  noindex = false,
}) => {
  const currentUrl = canonicalUrl || (typeof window !== 'undefined' ? window.location?.href : '');
  const siteName = 'ADT Express';

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <html lang="fr" />
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {!noindex && <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />}
      <meta name="googlebot" content="index, follow" />
      <meta name="language" content="French" />
      <meta name="author" content="ADT Express" />
      
      {/* Canonical URL */}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="fr_FR" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={currentUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Additional SEO Meta Tags */}
      <meta name="geo.region" content="FR" />
      <meta name="geo.placename" content="Paris" />
      <meta name="geo.position" content="48.856614;2.3522219" />
      <meta name="ICBM" content="48.856614, 2.3522219" />
      
      {/* Structured Data JSON-LD */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHelmet;